/**
 * Lightweight metadata for the active LLM Kate is talking to.
 *
 * Kept as a frontend constant (not plumbed from the backend response) because
 * we currently use a single hardcoded default in `aiHandler.go` and changing
 * it requires a backend release anyway. If/when we add a per-session model
 * picker, replace consumers of `ACTIVE_MODEL` with the picker's state.
 *
 * Source of truth for the actual Bedrock invocation is
 *   telemetry-backend/rest/aiHandler.go → defaultModelID
 * Keep this file in sync when bumping the backend default.
 */

export interface ModelInfo {
  /** Bedrock inference profile / model ID — matches `defaultModelID` server-side. */
  id: string;
  /** Short label shown in the UI chip. */
  label: string;
  /** Family name for tooltips. */
  family: string;
}

export const ACTIVE_MODEL: ModelInfo = {
  id: "us.anthropic.claude-opus-4-7",
  label: "Opus 4.7",
  family: "Claude",
};
